module.exports = __webpack_public_path__ + "img/AvatarBronze.2369251c.svg";